export default function Partnership() {
  const handlePartnerClick = () => {
    const partnershipForm = document.getElementById('partnership-form-section');
    if (partnershipForm) {
      partnershipForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="partnership-section" className="py-20 bg-zinc-950">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-white mb-8">
          Partner With a Reliable Field Execution Team
        </h2>
        <p className="text-gray-300 text-lg leading-relaxed mb-10 max-w-3xl mx-auto">
          We support MSPs and IT integrators requiring dependable on-site deployment services. If you need scalable field support across NYC or nationwide, ZJF IT Services LLC is ready to assist.
        </p>
        <button 
          onClick={handlePartnerClick}
          className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-base"
        >
          Start a Partnership Conversation
        </button>
      </div>
    </section>
  );
}